import TipTapRenderer from '../components/TipTapRenderer';
import { GetReservation200 } from '../../openapi/model';
import { useLang } from '../hooks/useLanguage';

function NeedToKnow({ reservation }: { reservation: GetReservation200 }) {
    const { t, getI18n } = useLang();

    const hasContent =
        (reservation?.needToKnow &&
            (typeof reservation.needToKnow !== 'object' ||
                (reservation.needToKnow as { content?: unknown[] })?.content?.length)) ||
        (reservation?.needToKnowI18n && Object.keys(reservation.needToKnowI18n).length > 0);

    if (!hasContent) return null;

    return (
        <div className="fireknife-booking-cancellation">
            <h2 className="fireknife-booking-cancellation__title">
                {t('widgetBookingSummary.needToKnow')}
            </h2>
            <div className="fireknife-booking-cancellation__desc">
                <TipTapRenderer
                    content={getI18n(reservation?.needToKnow, reservation?.needToKnowI18n)}
                />
            </div>
        </div>
    );
}

export default NeedToKnow;
